import { filter_ALL } from "./filter_campsites";
import { cgSearchResponse, searchParams } from "./type_defs";

export const get_wishesToken = async () => {
	let token:string;
	let errMsg:string;
	let success:boolean = false;

	await $.ajax({
		type: "get",
		url: "/AG_wishes_token",
		dataType: "text",
		success: (data) => {
			success = true;
			token = data;
		},
		error: (xhr, errStr, exc) => {
			errMsg = errStr;
		}
	});

	return new Promise<string>((resolve,reject) => {
		if (success) resolve(token);
		else reject(Error(errMsg));
	});
};

export const send_getAPItoken = async () => {
	let token:string;
	let errMsg:string;
	let success:boolean = false;

	await $.ajax({
		type: "get",
		url: "/AG_api_token",
		dataType: "text",
		success: (data) => {
			success = true;
			token = data;
		},
		error: (xhr, errStr, exc) => {
			errMsg = errStr;
		}
	});

	return new Promise<string>((resolve,reject) => {
		if (success) resolve(token);
		else reject(Error(errMsg));
	});
};

export const send_ai_cg_search = async (apiToken:string, query:string) => {
	let success:boolean = false;
	let response:any;
	let errMsg:string;

	await $.ajax({
		type: "post",
		url: "/ai_cg_search",
		headers: {
			"Authorization": `Bearer ${apiToken}`
		},
		data: JSON.stringify({
			query: query
		}),
		contentType: "application/json",
		dataType: "json",
		success: (data) => {
			success = true;
			response = data;
		},
		error: (xhr, errStr, exc) => {
			success = false;
			errMsg = errStr;
		}
	});

	return new Promise<cgSearchResponse>((resolve,reject) => {
		if (success) resolve(response);
		else reject(Error(errMsg));
	});
};

export const send_cgSearchRequest = async (params: searchParams) => {
	let success:boolean = false;
	let response:cgSearchResponse;
	let errMsg:string;

	params.instantBook = $("#instantBook").hasClass("active");

	await $.ajax({
		type: "post",
		url: "./campground_search",
		data: JSON.stringify(params),
		contentType: "application/json",
		dataType: "json",
		success: (data) => {
			success = true;
			response = data;
			filter_ALL();
		},
		error: (xhr, errStr, exc) => {
			success = false;
			errMsg = errStr;
		}
	});

	return new Promise<cgSearchResponse>((resolve,reject) => {
		if (success) resolve(response);
		else reject(Error(errMsg));
	});
};

export const send_getTopCamps = async () => {
	let results:string;
	let success:boolean = false;
	let errMsg:string;

	await $.ajax({
		type:"get",
		url:"/topCamps",
		dataType:"html",
		success: (data) => {success=true;results=data;},
		error: (xhr, errStr, exc) => {
			success = false;
			errMsg = errStr;
		}
	});

	return new Promise<string>((resolve,reject) => {
		if (success) resolve(results);
		else reject(Error(errMsg));
	})
};

export const send_getTopSponsoredCamps = async () => {
	let results:string;
	let success:boolean = false;
	let errMsg:string;

	await $.ajax({
		type:"get",
		url:"/topSponsoredCamps",
		dataType:"html",
		success: (data) => {success=true;results=data;},
		error: (xhr, errStr, exc) => {
			success = false;
			errMsg = errStr;
		}
	});

	return new Promise<string>((resolve,reject) => {
		if (success) resolve(results);
		else reject(Error(errMsg));
	})
};

export const send_getLikedCamps = async () => {
	let results:string;
	let success:boolean = false;
	let errMsg:string;

	await $.ajax({
		type:"get",
		url:"/likedCamps",
		dataType:"html",
		success: (data) => {success=true;results=data;},
		error: (xhr, errStr, exc) => {
			success = false;
			errMsg = errStr;
		}
	});

	return new Promise<string>((resolve,reject) => {
		if (success) resolve(results);
		else reject(Error(errMsg));
	})
};

export const send_getNearbyCamps = async (campID:string) => {
	let results:string;
	let success:boolean = false;
	let errMsg:string;

	await $.ajax({
		type:"post",
		url:"/nearbyCamps",
		data: JSON.stringify({
			campID: campID
		}),
		contentType: "application/json",
		dataType:"html",
		success: (data) => {success=true;results=data;},
		error: (xhr, errStr, exc) => {
			success = false;
			errMsg = errStr;
		}
	});

	return new Promise<string>((resolve,reject) => {
		if (success) resolve(results);
		else reject(Error(errMsg));
	})
};
